/*
 * Module for the Job Listing Index View
 */
rs.module("content/jobs/index",

    [],

    function () {

        // Initialize the page
        function initialize(jsSelectors, cssClasses, backendUrls) {

            // Hook up favorite icon click handler 
            $(document).onjs("click", jsSelectors.favoriteIcon, _onFavoriteClick); 

            // Favorite icon click handler
            function _onFavoriteClick() {

                // call backend to save favorite job
                $.post(backendUrls.saveFavoriteJob, {
                    "jobid": $(this).data("jobid")
                });

                // toggle favorite icon css class
                $(this).toggleClass(cssClasses.favorite);
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);